import React, { type ReactNode } from 'react';

import { useServerStatusToast } from '@/hooks/useServerStatusToast';

interface MainLayoutProps {
  children: ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  useServerStatusToast();

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col bg-background">
      {/* No bottom-nav clearance: the mobile bottom navigation is disabled
          (Navbar.tsx · ENABLE_MOBILE_BOTTOM_NAV = false, 2026-04-20), so the
          old `pb-[68px]` reserved phantom space for a bar that no longer
          renders — it left a 68px dead gap under bottom-anchored content like
          the /create composer. Per-surface safe-area padding (e.g. the composer
          block's `env(safe-area-inset-bottom)`) handles the home indicator. */}
      {/*
       * AppLayout owns the default route scroller. Keep this wrapper overflow-visible
       * so document-like pages contribute their full height to that scroll region;
       * canvas pages such as Calendar create their own bounded inner scroller.
       */}
      <div className="flex min-h-0 flex-1 flex-col transition duration-200">{children}</div>
    </div>
  );
};

export default MainLayout;
